
import * as api from '@/api/'
import { joinImgPrefix, relaceToBr, getSpecialReligiousAssemblyRecord } from '@/utils/'
import validate from '@/utils/validate'
import { dateFormat } from '@/utils/dateUtil'
import { getColumnId } from '@/config/column'
let mixin = {
  joinImgPrefix,
  relaceToBr,
  dateFormat,
  validate,
  getColumnId,
  getSpecialReligiousAssemblyRecord
}

// api
for (let key in api) {
  mixin[key] = api[key]
}

export default mixin